module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/fa98f5b1ca0cc2943e19ecd1d2d2cbb0.svg";